module.exports = __webpack_public_path__ + "img/Canvas-buttom.594a5f3c.png";